// @ts-nocheck
import $ from "jquery";

// Abgeleitet von http://stackoverflow.com/a/3160718
(() => {
	var $favoritenliste = $(".favoritenliste");

	if ($favoritenliste.length === 0) {
		return;
	}

	$favoritenliste.each(function() {
		var $tabelle = $(this);
		var $tabelleThs = $tabelle.find("th[data-sort]");
		var $tabelleThSpans = $tabelle.find("span");

		$tabelleThs.each(function() {
			var $tabelleTh = $(this);
			var $tabelleThIndex = $tabelleTh.index();

			$tabelleTh.on("click", function() {
				var $tabelleTds = $tabelle.find("td").filter(function() {
					return $(this).index() === $tabelleThIndex;
				});
				var absteigend = $tabelleTh.attr("data-sort") === "asc"; // Achtung Drehung berücksichtigen!

				sortElements.call($tabelleTds, (a, b) => {
					var aInput = $(a).find("input");
					var bInput = $(b).find("input");
					var aText;
					var bText;

					if (aInput.length === 1 && bInput.length === 1) {
						aText = $(aInput[0]).val();
						bText = $(bInput[0]).val();
					} else {
						aText = trimWhiteSpace($.text([a]));
						bText = trimWhiteSpace($.text([b]));
					}

					return aText > bText ?
						absteigend ? -1 : 1
						: absteigend ? 1 : -1;

				}, (el) => el.parentNode);

				$tabelleThs.attr("data-sort", "");
				$tabelleThSpans.text("");
				if (absteigend === true) {
					$tabelleTh.attr("data-sort", "desc");
					$tabelleTh.find("span").text("▾");
				} else {
					$tabelleTh.attr("data-sort", "asc");
					$tabelleTh.find("span").text("▴");
				}
			});
		});
	});

	function trimWhiteSpace(value) {
		return value.replace(/^\s+|\s+$/gm, "");
	}
})();

/**
 * jQuery.fn.sortElements
 * @author James Padolsey (http://james.padolsey.com)
 * Abgewandelt für non-globale Verwendung
 */
function sortElements(comparator, getSortable) {
	getSortable = getSortable || function() { return this; };

	var placements = this.map(function() {
		var sortElement = getSortable(this),
			parentNode = sortElement.parentNode,

			// Since the element itself will change position, we have
			// to have some way of storing it's original position in
			// the DOM. The easiest way is to have a "flag" node:
			nextSibling = parentNode.insertBefore(
				document.createTextNode(""),
				sortElement.nextSibling
			);

		return function() {
			if (parentNode === this) {
				throw new Error("You can't sort elements if any one is a descendant of another.");
			}

			// Insert before flag:
			parentNode.insertBefore(this, nextSibling);
			// Remove flag:
			parentNode.removeChild(nextSibling);
		};
	});

	Array.prototype.sort.call(this, comparator).each(function(i) {
		placements[i].call(getSortable.call(this));
	});
};
